// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Lexend:wght@400;600;700;800&family=Inter:wght@300;400;500;600;700&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.philosophy-page {
  --ph-type-heading: clamp(2.1rem, 3vw, 3rem);
  --ph-type-subheading: 1.6rem;
  --ph-type-card-heading: 1.3rem;
  --ph-type-body: 1.08rem;
  --ph-type-label: 0.9rem;
  --bg: #f6f2fa;
  --surface: #ffffff;
  --text: #0b1220;
  --muted: #5f6175;
  --accent: #370b3b;
  --accent-soft: #e9dff8;
  --border: rgba(55, 11, 59, 0.15);
  background: var(--bg);
  color: var(--text);
  font-family: 'Inter', system-ui, -apple-system, Segoe UI, Roboto, sans-serif;
  min-height: 100vh;
  width: 100%;
  padding: 36px 0.5rem 60px;
}

.philosophy-hero {
  max-width: 1200px;
  margin: 0 auto 44px;
  text-align: center;
}

.hero-badge {
  display: inline-flex;
  align-items: center;
  gap: 0.25rem;
  padding: 6px 20px;
  border-radius: 999px;
  background: var(--accent-soft);
  color: var(--accent);
  font-weight: 700;
  letter-spacing: 0.2em;
  font-size: var(--ph-type-label);
  text-transform: uppercase;
  border: 1px solid var(--border);
}

.philosophy-hero h1 {
  font-family: 'Lexend', system-ui, -apple-system, Segoe UI, Roboto, sans-serif;
  font-size: var(--ph-type-heading);
  font-weight: 800;
  margin: 16px 0;
}

.philosophy-hero h1 span {
  display: block;
  color: var(--accent);
}

.philosophy-hero p {
  max-width: 760px;
  margin: 0 auto;
  color: var(--muted);
  line-height: 1.7;
  font-size: var(--ph-type-body);
}

.founder-section {
  max-width: 1460px;
  margin: 0 auto 40px;
  display: flex;
  flex-direction: column;
  gap: 40px;
}

.founder-card {
  background: var(--surface);
  border-radius: 28px;
  padding: 32px;
  display: grid;
  grid-template-columns: 1fr 2fr;
  gap: 36px;
  border: 1px solid var(--border);
  box-shadow: 0 16px 40px rgba(55, 11, 59, 0.1);
}

.founder-image {
  position: relative;
  min-height: 340px;
  border-radius: 24px;
  overflow: hidden;
  background: #ece4ed;
}

.founder-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.image-label {
  position: absolute;
  bottom: 16px;
  left: 16px;
  background: rgba(0, 0, 0, 0.72);
  color: #fff;
  font-size: var(--ph-type-label);
  letter-spacing: 0.12em;
  padding: 6px 10px;
  border-radius: 999px;
}

.founder-content h2 {
  font-family: 'Lexend', system-ui, -apple-system, Segoe UI, Roboto, sans-serif;
  font-size: var(--ph-type-subheading);
  margin: 6px 0 12px;
}

.founder-role {
  font-weight: 700;
  color: var(--accent);
  letter-spacing: 0.12em;
  font-size: var(--ph-type-label);
}

.quote-card {
  background: var(--accent-soft);
  padding: 24px;
  border-radius: 22px;
  margin-bottom: 20px;
  border: 1px solid var(--border);
}

.quote-icon {
  font-size: 2rem;
  color: var(--accent);
  display: block;
  line-height: 1;
}

.quote-icon--end {
  text-align: right;
  margin-top: 0.25rem;
}

.quote-card p {
  margin: 0;
  color: var(--text);
  font-weight: 600;
  line-height: 1.5;
  font-size: var(--ph-type-body);
}

.founder-description {
  color: var(--muted);
  line-height: 1.65;
  font-size: var(--ph-type-body);
}

.philosophy-page section {
  max-width: 1200px;
  margin: 0 auto 32px;
  padding: 0 4px;
}

.philosophy-page section h2 {
  font-family: 'Lexend', system-ui, -apple-system, Segoe UI, Roboto, sans-serif;
  font-size: var(--ph-type-subheading);
  margin-bottom: 10px;
  color: var(--accent);
}

.philosophy-page section p {
  color: var(--muted);
  line-height: 1.6;
  font-size: var(--ph-type-body);
}

.philosophy-page section ul {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
  margin-bottom: 12px;
}

.philosophy-page section li {
  position: relative;
  padding-left: 1rem;
  font-weight: 600;
  font-size: var(--ph-type-body);
}

.legacy-section li {
  color: #370b3b;
}

.culture-section li {
  color: #370b3b;
}

.philosophy-page section li::before {
  content: '•';
  position: absolute;
  left: 0;
  color: var(--accent);
  font-size: 1.2rem;
  line-height: 1;
}

.legacy-note,
.culture-affirmation {
  color: #111111;
  font-weight: 700;
}

.message-section {
  border-top: 1px solid var(--border);
  padding-top: 24px;
  margin-top: 24px;
}

.message-hindi {
  font-size: clamp(1.9rem, 2.5vw, 2.3rem);
  font-weight: 600;
  line-height: 1.7;
  white-space: pre-line;
  color: orangered !important;

}

@media (max-width: 900px) {
  .founder-card {
    grid-template-columns: 1fr;
  }

  .founder-image {
    min-height: 220px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/frontend/pages/Philosophy/philosophy.css"],"names":[],"mappings":"AAEA;EACE,2CAA2C;EAC3C,4BAA4B;EAC5B,8BAA8B;EAC9B,uBAAuB;EACvB,uBAAuB;EACvB,aAAa;EACb,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,sBAAsB;EACtB,gCAAgC;EAChC,qBAAqB;EACrB,kBAAkB;EAClB,4EAA4E;EAC5E,iBAAiB;EACjB,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,iBAAiB;EACjB,oBAAoB;EACpB,8BAA8B;EAC9B,oBAAoB;EACpB,gBAAgB;EAChB,qBAAqB;EACrB,+BAA+B;EAC/B,yBAAyB;EACzB,+BAA+B;AACjC;;AAEA;EACE,6EAA6E;EAC7E,iCAAiC;EACjC,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,8BAA8B;AAChC;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;EACnB,aAAa;EACb,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,+BAA+B;EAC/B,6CAA6C;AAC/C;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,UAAU;EACV,+BAA+B;EAC/B,WAAW;EACX,+BAA+B;EAC/B,sBAAsB;EACtB,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,6EAA6E;EAC7E,oCAAoC;EACpC,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;EACpB,sBAAsB;EACtB,+BAA+B;AACjC;;AAEA;EACE,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,+BAA+B;AACjC;;AAEA;EACE,eAAe;EACf,oBAAoB;EACpB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,8BAA8B;AAChC;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,8BAA8B;AAChC;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,6EAA6E;EAC7E,oCAAoC;EACpC,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,8BAA8B;AAChC;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;EACT,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,8BAA8B;AAChC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,OAAO;EACP,oBAAoB;EACpB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;;EAEE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,mCAAmC;EACnC,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,uCAAuC;EACvC,gBAAgB;EAChB,gBAAgB;EAChB,qBAAqB;EACrB,2BAA2B;;AAE7B;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,iBAAiB;EACnB;AACF","sourcesContent":["@import url(\"https://fonts.googleapis.com/css2?family=Lexend:wght@400;600;700;800&family=Inter:wght@300;400;500;600;700&display=swap\");\r\n\r\n.philosophy-page {\r\n  --ph-type-heading: clamp(2.1rem, 3vw, 3rem);\r\n  --ph-type-subheading: 1.6rem;\r\n  --ph-type-card-heading: 1.3rem;\r\n  --ph-type-body: 1.08rem;\r\n  --ph-type-label: 0.9rem;\r\n  --bg: #f6f2fa;\r\n  --surface: #ffffff;\r\n  --text: #0b1220;\r\n  --muted: #5f6175;\r\n  --accent: #370b3b;\r\n  --accent-soft: #e9dff8;\r\n  --border: rgba(55, 11, 59, 0.15);\r\n  background: var(--bg);\r\n  color: var(--text);\r\n  font-family: 'Inter', system-ui, -apple-system, Segoe UI, Roboto, sans-serif;\r\n  min-height: 100vh;\r\n  width: 100%;\r\n  padding: 36px 0.5rem 60px;\r\n}\r\n\r\n.philosophy-hero {\r\n  max-width: 1200px;\r\n  margin: 0 auto 44px;\r\n  text-align: center;\r\n}\r\n\r\n.hero-badge {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 0.25rem;\r\n  padding: 6px 20px;\r\n  border-radius: 999px;\r\n  background: var(--accent-soft);\r\n  color: var(--accent);\r\n  font-weight: 700;\r\n  letter-spacing: 0.2em;\r\n  font-size: var(--ph-type-label);\r\n  text-transform: uppercase;\r\n  border: 1px solid var(--border);\r\n}\r\n\r\n.philosophy-hero h1 {\r\n  font-family: 'Lexend', system-ui, -apple-system, Segoe UI, Roboto, sans-serif;\r\n  font-size: var(--ph-type-heading);\r\n  font-weight: 800;\r\n  margin: 16px 0;\r\n}\r\n\r\n.philosophy-hero h1 span {\r\n  display: block;\r\n  color: var(--accent);\r\n}\r\n\r\n.philosophy-hero p {\r\n  max-width: 760px;\r\n  margin: 0 auto;\r\n  color: var(--muted);\r\n  line-height: 1.7;\r\n  font-size: var(--ph-type-body);\r\n}\r\n\r\n.founder-section {\r\n  max-width: 1460px;\r\n  margin: 0 auto 40px;\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 40px;\r\n}\r\n\r\n.founder-card {\r\n  background: var(--surface);\r\n  border-radius: 28px;\r\n  padding: 32px;\r\n  display: grid;\r\n  grid-template-columns: 1fr 2fr;\r\n  gap: 36px;\r\n  border: 1px solid var(--border);\r\n  box-shadow: 0 16px 40px rgba(55, 11, 59, 0.1);\r\n}\r\n\r\n.founder-image {\r\n  position: relative;\r\n  min-height: 340px;\r\n  border-radius: 24px;\r\n  overflow: hidden;\r\n  background: #ece4ed;\r\n}\r\n\r\n.founder-image img {\r\n  width: 100%;\r\n  height: 100%;\r\n  object-fit: cover;\r\n  display: block;\r\n}\r\n\r\n.image-label {\r\n  position: absolute;\r\n  bottom: 16px;\r\n  left: 16px;\r\n  background: rgba(0, 0, 0, 0.72);\r\n  color: #fff;\r\n  font-size: var(--ph-type-label);\r\n  letter-spacing: 0.12em;\r\n  padding: 6px 10px;\r\n  border-radius: 999px;\r\n}\r\n\r\n.founder-content h2 {\r\n  font-family: 'Lexend', system-ui, -apple-system, Segoe UI, Roboto, sans-serif;\r\n  font-size: var(--ph-type-subheading);\r\n  margin: 6px 0 12px;\r\n}\r\n\r\n.founder-role {\r\n  font-weight: 700;\r\n  color: var(--accent);\r\n  letter-spacing: 0.12em;\r\n  font-size: var(--ph-type-label);\r\n}\r\n\r\n.quote-card {\r\n  background: var(--accent-soft);\r\n  padding: 24px;\r\n  border-radius: 22px;\r\n  margin-bottom: 20px;\r\n  border: 1px solid var(--border);\r\n}\r\n\r\n.quote-icon {\r\n  font-size: 2rem;\r\n  color: var(--accent);\r\n  display: block;\r\n  line-height: 1;\r\n}\r\n\r\n.quote-icon--end {\r\n  text-align: right;\r\n  margin-top: 0.25rem;\r\n}\r\n\r\n.quote-card p {\r\n  margin: 0;\r\n  color: var(--text);\r\n  font-weight: 600;\r\n  line-height: 1.5;\r\n  font-size: var(--ph-type-body);\r\n}\r\n\r\n.founder-description {\r\n  color: var(--muted);\r\n  line-height: 1.65;\r\n  font-size: var(--ph-type-body);\r\n}\r\n\r\n.philosophy-page section {\r\n  max-width: 1200px;\r\n  margin: 0 auto 32px;\r\n  padding: 0 4px;\r\n}\r\n\r\n.philosophy-page section h2 {\r\n  font-family: 'Lexend', system-ui, -apple-system, Segoe UI, Roboto, sans-serif;\r\n  font-size: var(--ph-type-subheading);\r\n  margin-bottom: 10px;\r\n  color: var(--accent);\r\n}\r\n\r\n.philosophy-page section p {\r\n  color: var(--muted);\r\n  line-height: 1.6;\r\n  font-size: var(--ph-type-body);\r\n}\r\n\r\n.philosophy-page section ul {\r\n  list-style: none;\r\n  padding: 0;\r\n  margin: 0;\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 0.4rem;\r\n  margin-bottom: 12px;\r\n}\r\n\r\n.philosophy-page section li {\r\n  position: relative;\r\n  padding-left: 1rem;\r\n  font-weight: 600;\r\n  font-size: var(--ph-type-body);\r\n}\r\n\r\n.legacy-section li {\r\n  color: #370b3b;\r\n}\r\n\r\n.culture-section li {\r\n  color: #370b3b;\r\n}\r\n\r\n.philosophy-page section li::before {\r\n  content: '•';\r\n  position: absolute;\r\n  left: 0;\r\n  color: var(--accent);\r\n  font-size: 1.2rem;\r\n  line-height: 1;\r\n}\r\n\r\n.legacy-note,\r\n.culture-affirmation {\r\n  color: #111111;\r\n  font-weight: 700;\r\n}\r\n\r\n.message-section {\r\n  border-top: 1px solid var(--border);\r\n  padding-top: 24px;\r\n  margin-top: 24px;\r\n}\r\n\r\n.message-hindi {\r\n  font-size: clamp(1.9rem, 2.5vw, 2.3rem);\r\n  font-weight: 600;\r\n  line-height: 1.7;\r\n  white-space: pre-line;\r\n  color: orangered !important;\r\n\r\n}\r\n\r\n@media (max-width: 900px) {\r\n  .founder-card {\r\n    grid-template-columns: 1fr;\r\n  }\r\n\r\n  .founder-image {\r\n    min-height: 220px;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
